// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvUpload-PayoutInstructions_cls1__OFJ3P","cls2":"GroupCsvUpload-PayoutInstructions_cls2__VEbIM GroupCsvUpload-PayoutInstructions_cls1__OFJ3P"};